import React from "react";
import { observer } from "mobx-react";
import { DocumentGenerationParamsCreateStore } from "../../store";
import { DocumentGenerationParamsCreateForm } from "./DocumentGenerationParamsCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type DocumentGenerationParamsCreateProps = {
  documentGenerationParamsCreateStore: DocumentGenerationParamsCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const DocumentGenerationParamsCreate: React.FC<DocumentGenerationParamsCreateProps> =
  observer(
    ({
      documentGenerationParamsCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={documentGenerationParamsCreateStore.isSaving} />
          <DocumentGenerationParamsCreateForm
            documentGenerationParamsCreateStore={
              documentGenerationParamsCreateStore
            }
            contractEffectiveDateError={
              documentGenerationParamsCreateStore.errors.contractEffectiveDate
                ?.message
            }
            onContractEffectiveDateChange={(value) => {
              documentGenerationParamsCreateStore.setContractEffectiveDateValue(
                value
              );
            }}
            contractEffectiveDate={
              documentGenerationParamsCreateStore.entityValues
                .contractEffectiveDate
            }
            contractEndDateError={
              documentGenerationParamsCreateStore.errors.contractEndDate
                ?.message
            }
            onContractEndDateChange={(value) => {
              documentGenerationParamsCreateStore.setContractEndDateValue(
                value
              );
            }}
            contractEndDate={
              documentGenerationParamsCreateStore.entityValues.contractEndDate
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={documentGenerationParamsCreateStore.isProcessing}
            onSave={() =>
              documentGenerationParamsCreateStore.saveNewDocumentGenerationParams()
            }
            onCancel={() =>
              documentGenerationParamsCreateStore.cancelNewDocumentGenerationParams()
            }
          />
          <ErrorDialog
            open={documentGenerationParamsCreateStore.errorDialogOpened}
            title={documentGenerationParamsCreateStore.errorTitle}
            description={documentGenerationParamsCreateStore.errorDescription}
            onClose={() =>
              documentGenerationParamsCreateStore.closeErrorDialog()
            }
          />
        </>
      );
    }
  );
